import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IChatHistoryItem {
  chat_history_id: string;
  title: string;
  created_at: string;
  group: string;
}

export interface IChatHistory {
  activeChatId?: string;
  recentChats: IChatHistoryItem[];
  olderChats: IChatHistoryItem[];
}

const chatHistoryInitialState: IChatHistory = {
  recentChats: [],
  olderChats: [],
};

const chatItemIndex = (history: IChatHistoryItem[], itemId: string) =>
  history.findIndex(({ chat_history_id }: IChatHistoryItem) => chat_history_id === itemId);

const chatHistorySlice = createSlice({
  name: 'chatHistory',
  initialState: chatHistoryInitialState,
  reducers: {
    setChatHistoryData: (state, action: PayloadAction<IChatHistory>) => ({ ...action.payload }),
    updateActiveChat: (state, action: PayloadAction<string>) => ({ ...state, activeChatId: action.payload }),
    addHistoryItem: (state, action: PayloadAction<IChatHistoryItem>) => {
      let { recentChats } = state;
      recentChats = [action.payload, ...recentChats];
      return { ...state, recentChats };
    },
    deleteHistoryItem: (state, action: PayloadAction<{ type: string; index: number }>) => {
      const { type, index } = action.payload;
      if (type === 'recentChats') {
        state.recentChats.splice(index, 1);
      } else {
        state.olderChats.splice(index, 1);
      }
      return state;
    },
    updateHistoryItem: (state, action: PayloadAction<IChatHistoryItem>) => {
      const { chat_history_id, title, group } = action.payload;
      if (group) {
        const tempState = group === 'recentChats' ? state.recentChats : state.olderChats;
        const index = chatItemIndex(tempState, chat_history_id);
        if (index > -1) {
          tempState[index].title = title;
        }
      }
      return state;
    },
    resetHistoryData: () => chatHistoryInitialState,
  },
});

export const {
  addHistoryItem,
  deleteHistoryItem,
  setChatHistoryData,
  updateHistoryItem,
  resetHistoryData,
  updateActiveChat,
} = chatHistorySlice.actions;
export default chatHistorySlice.reducer;
